export default {
    login: {
        loading: 'Du wirst bei oaseBW angemeldet...',
        success: 'Du bist jetzt bei oaseBW angemeldet.',
        redirecting: 'Du wirst gleich weitergeleitet...',
        error: 'Fehler bei der Anmeldung',
    },

    refresh: {
        error: 'Fehler beim Aktualisieren der Anmeldung',
    }
}